<template>
  <div class="buttons">
    <b-button :href="`tel:${phone}`" class="button-phone">
      {{ translate.result.cardReseller.call }}
      <i class="bi bi-telephone icon" />
    </b-button>
    <b-button
      :href="`https://wa.me/+55${whatsapp}`"
      target="_blank"
      variant="success"
      class="button-whatsapp"
    >
      {{ translate.result.cardReseller.whatsapp }}
      <i class="bi bi-whatsapp icon" />
    </b-button>
  </div>
</template>

<script>
export default {
  name: "buttons-card",
  props: {
    phone: {
      type: String,
      required: true,
    },
    whatsapp: {
      type: String,
      required: true,
    },
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
  }
};
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  height: 100%;

  @media (max-width: 780px) {
    display: flex;
    flex-direction: column;
    margin-left: 5px;
    height: 100%;
    margin-top: 5px;
    margin-left: 0px;
  }
}

.button-phone {
  background: #1e2b5a;
  width: 48%;

  @media (max-width: 780px) {
    width: 100%;
    margin-bottom: 5px;
  }
}

.button-whatsapp {
  width: 48%;
  @media (max-width: 780px) {
    width: 100%;
  }
}

.icon {
  margin-left: 10px;
}
</style>
